import api from './client'

export const searchAdresse = (q) =>
  api.get('/geo/adresse/search', { q })

export const reverseGeocode = (lat, lon) =>
  api.get('/geo/adresse/reverse', { lat, lon })

export const lookupParcelle = (params) =>
  api.get('/geo/adresse/parcelle', params)

export const analyseReglementation = (lat, lon, code_insee) =>
  api.get('/geo/reglementation/analyse', { lat, lon, code_insee })

export const analyseSituation = (lat, lon) =>
  api.get('/geo/situation/analyse', { lat, lon })

export const rechercheDVF = (params) =>
  api.get('/geo/dvf/recherche', params)

export const cartePrixDVF = (params) =>
  api.get('/geo/dvf/carte-prix', params)

export const generateCartesUrbanisme = (lat, lon) =>
  api.get('/geo/reglementation/cartes', { lat, lon })

export const downloadPLU = (data) =>
  api.post('/geo/reglementation/download-plu', data)

export const getParcellesGeojson = (lat, lon, radius = 100) =>
  api.get('/geo/adresse/parcelle/geojson', { lat, lon, radius })

export const reverseParcelle = (lat, lon) =>
  api.get('/geo/adresse/parcelle/reverse', { lat, lon })

export const estimateAVM = (expertiseId) =>
  api.post('/geo/avm/estimate', { expertise_id: expertiseId })

export const estimateAVMPro = (expertiseId) =>
  api.post('/geo/avm-pro/estimate', { expertise_id: expertiseId })

/**
 * Calcule altimétrie (pente, altitude, orientation) d'une parcelle.
 * Appelle l'endpoint backend Task 3 qui interroge l'API Géoplateforme
 * altimétrie IGN (RGE_ALTI) pour N points échantillonnés dans le polygone.
 *
 * @param {object} geometry - GeoJSON Polygon (coordonnées en WGS84)
 * @param {number} [targetSamples=100] - Nombre cible de points d'échantillonnage
 * @returns {Promise<{altitude_moyenne_m: number, altitude_min_m: number, altitude_max_m: number, denivele_m: number, pente_pct: number, pente_pct_max: number, orientation_azimut_deg: number, relief_classifie: string|null, geodesie_classifiee: string|null, rapport: object}>}
 */
export const calculerAltimetrie = (geometry, targetSamples = 100) =>
  api.post('/geo/altimetrie/parcelle', {
    geometry,
    target_samples: targetSamples,
  })
